import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Navigate, Outlet, useLocation, useSearchParams } from 'react-router-dom'
import { useAuth, MainAppApi  } from '_services'
import { setCredentials } from '_reducers'
import { LoadingScreen } from '_templates'

const { useGetProfileQuery } = MainAppApi

const PrivateRoute = () => {
  const [skip, setSkip] = useState(true)
  const { profile } = useAuth()
  const location = useLocation()
  const [searchParams] = useSearchParams()
  const dispatch = useDispatch()
  const [bootstrappedLocalAuth, setBootstrappedLocalAuth] = useState(false)

  useEffect(() => {
    if (profile.userType || bootstrappedLocalAuth) return

    const localProfile = JSON.parse(localStorage.getItem('profile'))
    if (localProfile?.token && localProfile?.userType) {
      dispatch(setCredentials(localProfile))
    }

    setBootstrappedLocalAuth(true)
  }, [bootstrappedLocalAuth, dispatch, profile.userType])

  const authToken = searchParams.get('auth_token')
  const shouldQueryMainAppProfile = !profile.userType && !localStorage.getItem('profile') && !!authToken && !skip
  const { data: profileData, isLoading } = useGetProfileQuery({}, { skip: !shouldQueryMainAppProfile })

  const redirectToLogin = (
    <Navigate
      to= '/login'
      state= {{ from: location }}
    />
  )

  if (!bootstrappedLocalAuth) {
    return <LoadingScreen />
  }

  if (isLoading) {
    return <LoadingScreen />
  }

  if (!profile.userType) {
    const mainAppSource = !!authToken

    if (!mainAppSource) return redirectToLogin

    if (skip) {
      dispatch(setCredentials({ token: authToken }))
      setSkip(false)
      return <LoadingScreen />
    }

    if (profileData) {
      dispatch(setCredentials({ token: authToken, userType: 'mainApp' }))
      setSkip(true)
      return <LoadingScreen />
    }
  }

  return profile.userType ? (
    <Outlet />
  ) : redirectToLogin
}

export default PrivateRoute
